
import { Bell, LogOut, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function UserHeader() {
  const { user, signOut } = useAuth();

  return (
    <header className="bg-black border-b border-gray-800 p-4">
      <div className="flex items-center justify-between max-w-md mx-auto">
        <div className="flex items-center">
          <Link to="/">
            <span className="text-2xl font-bold text-[#FFFCF3]">BeerDrop</span>
            <span className="ml-2 text-[#089BDF]">▼</span>
          </Link>
        </div>
        
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="icon" className="text-[#FFFCF3]">
            <Bell size={20} />
          </Button>
          
          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon" className="text-[#FFFCF3] rounded-full">
                  <User size={20} />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-gray-900 border-gray-700 text-[#FFFCF3]">
                <DropdownMenuItem 
                  className="cursor-pointer hover:bg-gray-800"
                  onClick={() => signOut()}
                >
                  <LogOut className="mr-2 h-4 w-4" />
                  <span>Sign out</span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <Link to="/auth">
              <Button size="sm" variant="outline" className="border-[#089BDF] text-[#089BDF]">
                Sign In
              </Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
